/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Delete_ConfirmInputs */

const en_templates_delete_confirm = /** @type {(inputs: Templates_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this template? It will no longer be applied to new lessons.`)
};

const he_templates_delete_confirm = /** @type {(inputs: Templates_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למחוק את התבנית הזו? היא לא תוחל יותר על שיעורים חדשים.`)
};

/**
* | output |
* | --- |
* | "Delete this template? It will no longer be applied to new lessons." |
*
* @param {Templates_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_delete_confirm = /** @type {((inputs?: Templates_Delete_ConfirmInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Delete_ConfirmInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_delete_confirm(inputs)
	return he_templates_delete_confirm(inputs)
});